<template>
    <div class="list_nav_wrap clearfix">
        <h1 class="list_nav_title">
            <label>{{ keyName }}</label>
        </h1>
        <div class="sc-option clearfix" data-ui="dropdown" id="brand_option" style="z-index: 994;">
            <div class="sc-option-hd"
                @click="showMinYear = true">
                <div class="sc-option-content">
                    {{ activeMinYear }}
                </div>
                <div class="sc-option-action">
                    <i></i>
                </div>
            </div>
            <ul v-if="showMinYear"
                class="sc-option-list" style="top: 25px;">
                <li v-for="item in list">
                    <a @click="doSelectMinYear(item.value)"
                    :id-data="item.value">
                        {{ item.name }}
                    </a>
                </li>
            </ul>
        </div>
        <span class="zhi">至</span>
        <div class="sc-option clearfix" data-ui="dropdown" id="brand_option" style="z-index: 994;">
            <div class="sc-option-hd"
                @click="showMaxYear = true">
                <div class="sc-option-content">
                    {{ activeMaxYear }}
                </div>
                <div class="sc-option-action">
                    <i></i>
                </div>
            </div>
            <ul v-if="showMaxYear"
                class="sc-option-list" style="top: 25px;">
                <li v-for="item in list">
                    <a @click="doSelectMaxYear(item.value)"
                    :id-data="item.value">
                        {{ item.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    export default {
        data() {
            return {
                keyName: '上牌时间',
                showMinYear: false,
                showMaxYear: false,
                activeMinYear: locationObj.search.get('minYear') || '起始时间',
                activeMaxYear: locationObj.search.get('maxYear') || '结束时间',
                list: (function () {
                    let d = new Date();
                    let thisYear = d.getFullYear();
                    let ret = [];
                    for (var i = thisYear; i >= 2004; i--) {
                        ret.push({
                            value: i,
                            name: i
                        });
                    }
                    ret.push({
                        value: false,
                        name: '不限'
                    });
                    return ret;
                })()
            };
        },
        methods: {
            doSelectMinYear(value) {
                if (value) {
                    locationObj.s('minYear', value)
                        .s('index', null).go();
                } else {
                    locationObj.s('minYear', null)
                        .s('index', null).go();
                }
            },
            doSelectMaxYear(value) {
                if (value) {
                    locationObj.s('maxYear', value)
                        .s('index', null).go();
                } else {
                    locationObj.s('maxYear', null)
                        .s('index', null).go();
                }
            }
        },
        mounted() {
            let $ = window.$;
            $('body').click((event) => {
                if (!$(event.target).closest('.sc-option').length) {
                    this.showMinYear = false;
                    this.showMaxYear = false;
                }
            });
        }
    };
</script>

<style lang="less" scoped>
    a {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// NavAge.vue?695f2e28